import { Component, Input } from '@angular/core';
import { SvgIconUtils } from '../../../common-library/svg-icon/svg-icon-utils';
import { Step } from '../step';

@Component({
  selector: 'ld-stepper-num',
  templateUrl: 'stepper-num.template.html',
  styleUrls: [ './stepper-num.style.css' ]
})

export class StepperNumComponent {
  @Input() public isActive: boolean;
  @Input() public step: Step;

  // it seems dynamically adding a class via the iconClass input,
  // as well as using [class.active] and [class.complete]
  // is only feasible if ngClass is used. Below are the default classes,
  // and the iconClass is added during ngOnInit()'s invocation
  private cssClassArray = [
    'stepper-num',
    'open-sans-font',
    'circle',
    'badge',
    'white',
    'center',
    'p05',
    'incomplete-step',
    'icon'];

  private getIconId(): string {
    if (this.step.isCompleted()) {
      return this.step.completedIconId;
    }

    return this.step.iconId;
  }
}
